import type { ReactNode } from "react";
import { renderToStaticMarkup } from "react-dom/server";

/**
 * Given a React node, it renders the node into a HTML string synchronously.
 *
 * https://18.react.dev/reference/react-dom/server/renderToString#removing-rendertostring-from-the-client-code
 */
export function reactNodeToHtmlString(node: ReactNode) {
  return renderToStaticMarkup(node);
}
